import { breakpoints } from "./sizes"

export const minW = breakpoints.map(bp => `@media (min-width: ${bp}px)`)

export const maxW = breakpoints.map(bp => `@media (max-width: ${bp}px)`)

export const betweenVals = (min, max) => {
    return `@media (min-width: ${min}) and (max-width: ${max})`
}
